import { useState } from 'react';
import { SignaturePad } from '../../components/phase3';
import type { SignatureValue } from '../../components/phase3';
import { t } from '../../lib/i18n';
import { CheckboxField, TextField } from '../../components/ui';

/** What the visitor gave: strokes drawn on the pad, or a typed full name (for people who cannot draw on a small screen). */
export type SignatureAnswer = { kind: 'drawn'; value: SignatureValue } | { kind: 'typed'; name: string };

/**
 * A signature the visitor can draw (W16 pad) or replace by typing their full name. Calls onChange(null) until there is
 * something usable. The typed name is never turned into fake strokes; the caller sends an empty stroke file plus the name.
 */
export function SignatureInput({ label, disabled, onChange }: { label: string; disabled?: boolean; onChange: (a: SignatureAnswer | null) => void }) {
  const [typed, setTyped] = useState(false);
  const [name, setName] = useState('');
  return (
    <div className="space-y-2">
      {typed ? (
        <TextField
          label={t('w21.signature.typedLabel', { label })}
          hint={t('w21.signature.typedHint')}
          value={name}
          maxLength={120}
          autoComplete="name"
          disabled={disabled}
          onChange={(e) => {
            setName(e.target.value);
            onChange(e.target.value.trim() ? { kind: 'typed', name: e.target.value.trim() } : null);
          }}
        />
      ) : (
        <SignaturePad label={label} disabled={disabled} onChange={(v) => onChange(v ? { kind: 'drawn', value: v } : null)} />
      )}
      <CheckboxField
        label={t('w21.signature.useTyped')}
        checked={typed}
        disabled={disabled}
        onChange={(e) => {
          setTyped(e.target.checked);
          setName('');
          onChange(null);
        }}
      />
    </div>
  );
}
